import {Constants} from './actions'


const initialState = {
  requesting: false,
  successful: false,
  data: {
    
  }
}


const reducer = function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.GET_DATA:
      return {
        ...state,
        requesting: true,
        successful: false,
      }
    case Constants.SET_DATA:
      return {
        ...state,
        successful: true,
        data: action.payload
      }
    case Constants.SET_LOADING:
      return {
        ...state,
        requesting: action.payload,
      }
    default:
      return state
  }
}

export default reducer


// WEBPACK FOOTER //
// ./src/components/Chart/reducer.js